import Vue from 'vue';
import qs from 'qs';
import jsonToFormData from 'json-form-data';

export default class FormUtils {
  static loadItemData (instance, config) {
    if (!config.id) {
      instance.id = parseInt(instance.$route.params.id, 10);
    } else {
      instance.id = parseInt(config.id, 10);
    }

    if (config.id === null) {
      instance.id = '';
    }

    let requestMethod = 'post';
    let parameters = config.params || {};

    if (config.method) {
      requestMethod = config.method;
    }

    if (config.method === 'get') {
      parameters = {
        params: parameters,
        paramsSerializer: params => qs.stringify(params)
      };
    }

    axios[requestMethod](config.endpointBase + instance.id, parameters).then(response => {
      if (response.data) {
        for (let i = 0; i < config.instanceFields.length; i++) {
          let fieldName = config.instanceFields[i];

          if (config.booleanFields && config.booleanFields.indexOf(fieldName) !== -1) {
            instance.data[fieldName] = !!response.data.data[fieldName];
          } else {
            instance.data[fieldName] = response.data.data[fieldName];
          }
        }

        if (config.loadedKey) {
          instance[config.loadedKey] = true;
        }

        if (config.successAction) {
          config.successAction(response.data.data);
        }
      } else {
        // eslint-disable-next-line
        if (config.errorKey) {
          instance[config.errorKey] = true;
        } else {
          instance.loadError = true;
        }
      }
    }).catch(error => {
      console.log(error);

      if (config.errorKey) {
        instance[config.errorKey] = true;
      } else {
        instance.loadError = true;
      }
    });
  }

  static submit (instance, config) {
    axios.post(
      config.endpoint,
      config.formData
    ).then(response => {
      if (response.data.success || response.status === 200) {
        FormUtils.submitShowSuccess(config, response);
      } else {
        FormUtils.submitShowError(config, response);
      }
    }).catch((error) => {
      FormUtils.submitShowError(config, error.response);
    });
  }

  static submitWithConfirm (instance, config, imageFields = false) {
    Vue.swal({
      title: config.confirmTitle,
      html: config.confirmText,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: config.confirmButtonText || 'Tak',
      cancelButtonText: 'Anuluj',
      buttonsStyling: true,
    }).then((result) => {
      if (result.value) {
        if (!imageFields || imageFields.length === 0) {
          axios.post(
            config.endpoint,
            config.formData,
            {
              withCredentials: true
            }
          ).then(response => {
            if (response.data.success) {
              FormUtils.submitShowSuccess(config, response);
            } else {
              FormUtils.submitShowError(config, response);
            }
          }).catch((error) => {
            FormUtils.submitShowError(config, error.response);
          });
        } else {
          axios.request({
            method: 'POST',
            url: config.endpoint,
            headers: { 'Content-Type': undefined },
            withCredentials: true,
            transformRequest: (data) => {
              let dataToSend = jsonToFormData(config.formData);

              for (let i = 0; i < imageFields.length; i++) {
                if (typeof imageFields[i] === 'string') {
                  dataToSend.append(imageFields[i], data[imageFields[i]]);
                } else {
                  dataToSend.append(imageFields[i].key, imageFields[i].value);
                }
              }

              return dataToSend;
            },
            data: config.formData
          }).then(response => {
            if (response.data.success) {
              FormUtils.submitShowSuccess(config, response);
            } else {
              FormUtils.submitShowError(config, response);
            }
          }).catch(error => {
            console.log(error);
            FormUtils.submitShowError(config, error.response);
          });
        }
      } else {
        config.cancelAction();
      }
    });
  }

  static submitShowError (config, response) {
    let errorText = config.errorText;

    if (response && response.data && response.data.msg) {
      errorText = response.data.msg;
    } else if (response && response.data && response.data.errors) {
      let keys = Object.keys(response.data.errors);
      errorText = [];

      for (let i = 0; i < keys.length; i++) {
        errorText.push(response.data.errors[keys[i]]);
      }

      errorText = errorText.join('<br>');
    } else if (response && response.data && response.data.error) {
      errorText = response.data.error;
    }

    Vue.swal({
      title: config.errorTitle,
      html: errorText,
      type: 'warning',
      confirmButtonText: 'OK',
      showConfirmButton: true,
      buttonsStyling: true
    }).then(() => {
      if (config.failAction) {
        config.failAction(response);
      }
    });
  }

  static submitShowSuccess (config, response) {
    Vue.swal({
      title: config.successTitle,
      html: config.successText,
      type: 'success',
      confirmButtonText: 'OK',
      showConfirmButton: true,
      buttonsStyling: true
    }).then(() => {
      if (config.successAction) {
        config.successAction(response.data);
      }
    }).catch((errors) => {
      console.log(errors);
    });
  }

  static loadAdditionalData (instance, config) {
    let errorKey = 'loadError';

    if (config.errorKey) {
      errorKey = config.errorKey;
    }

    let requestMethod = 'post';
    let parameters = config.params || {};

    if (config.method) {
      requestMethod = config.method;
    }

    if (config.method === 'get') {
      parameters = {
        params: parameters,
        paramsSerializer: params => qs.stringify(params)
      };
    }

    axios[requestMethod](config.endpoint, parameters)
    .then(response => {
      if (!response.data) {
        instance[errorKey] = true;
        return;
      }

      let responseData;

      if (config.noPagination) {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data[config.responseKey];
        } else {
          responseData = response.data;
        }
      } else {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data.data[config.responseKey];
        } else {
          responseData = response.data.data;
        }
      }

      if (config.booleanFields) {
        if (Array.isArray(responseData)) {
          for (let i = 0; i < responseData.length; i++) {
            for (let j = 0; j < config.booleanFields.length; j++) {
              let fieldName = config.booleanFields[j];
              responseData[i][fieldName] = !!responseData[i][fieldName];
            }
          }
        } else {
          for (let i = 0; i < config.booleanFields.length; i++) {
            let fieldName = config.booleanFields[i];
            responseData[fieldName] = !!responseData[fieldName];
          }
        }
      }

      if (config.wrapResponseIntoArray) {
        responseData = [responseData];
      }

      if (config.outputKeyIndex) {
        instance[config.outputKey][config.outputKeyIndex] = responseData;
      } else {
        instance[config.outputKey] = responseData;
      }

      instance[config.loadedKey] = true;

      if (config.successAction) {
        config.successAction(responseData);
      }
    }).catch(error => {
      console.log(error);
      instance[errorKey] = true;

      if (config.failAction) {
        config.failAction(error);
      }
    });
  }

  static submitInBackground (config) {
    axios.post(
      config.endpoint,
      config.params
    ).then(response => {
      if (config.successAction) {
        config.successAction(response.data);
      }
    }).catch(error => {
      console.log(error);

      if (config.failAction) {
        config.failAction(error.response);
      }

      if (!config.skipErrorDisplay) {
        FormUtils.submitShowError(config, error.response);
      }
    });
  }

  static async getNetValue (value) {
    if (!value) {
      return 0;
    };

    try {
      let { data, status, message } = await axios.post('api/calculation/get-netto-for-amount', { amount: value });
      if (!data || status !== 200) {
        throw new Error('Invalid unsuccessful response. ', message);
      }

      return {
        value: data.amount,
        isError: false
      };
    } catch (error) {
      console.log(error);
      return {
        value: data.amount,
        isError: true
      }
    }
  }

  static async getGrossValue (value) {
    if (!value) {
      return 0;
    };

    try {
      let { data, status, message } = await axios.post('api/calculation/get-brutto-for-amount', { amount: value });
      if (!data || status !== 200) {
        throw new Error('Invalid unsuccessful response. ', message);
      }

      return {
        value: data.amount,
        isError: false
      };
    } catch (error) {
      console.log(error);
      return {
        value: data.amount,
        isError: true
      }
    }
  }
}
